import React, { useState } from "react";
import "./RoofConditionInput.css";

const options = [
  { label: "Excellent", emoji: "🏆" },
  { label: "Good",      emoji: "✅" },
  { label: "Fair",      emoji: "⚠️" },
  { label: "Poor",      emoji: "🔧" },
];

export default function RoofConditionInput({ nextStep, updateFormData }) {
  const [selected, setSelected] = useState("");

  const handleContinue = () => {
    if (!selected) {
      alert("Please select your roof condition.");
      return;
    }
    updateFormData({ roofCondition: selected });
    nextStep();
  };

  return (
    <div className="roof-condition-container">
      <h2>What condition is your roof in?</h2>
      <p className="intro-para">
        The condition of your roof affects installation feasibility and the long-term
        performance of your solar system.{" "}
        <em>If you're unsure, Good is a reasonable assumption for most well-maintained homes.</em>
      </p>
      <div className="condition-options">
        {options.map(({ label, emoji }) => (
          <button
            key={label}
            type="button"
            className={selected === label ? "condition-btn selected" : "condition-btn"}
            onClick={() => setSelected(label)}
          >
            {emoji} {label}
          </button>
        ))}
      </div>
      <button className="continue-button" onClick={handleContinue}>
        Continue
      </button>
    </div>
  );
}
